/**
 * Created By Henal Khianra
 * Created at 27/02/2020
 * https://marvelapp.com/4g4b5dg/screen/58840158
 */

import React from 'react';
import loadable from '@loadable/component';
import { Document, Font, Page, pdf, StyleSheet, Text, View } from '@react-pdf/renderer';
import Icon from '@components/@core/Icon';
import { formatDate } from '~/services/util';

const Header = loadable(() => import('@components/PdfHeader'), { ssr: false });

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        alignItems: 'stretch',
    },
    listHeader: {
        display: 'flex',
        flexDirection: 'row',
        margin: '9px 10px 0px 10px',
        paddingBottom: '10px',
        paddingTop: '3px',
        borderBottomWidth: 1.3,
        borderBottomColor: 'gray',
        borderBottomStyle: 'solid',
    },
    mainHeader: {
        display: 'flex',
        flexDirection: 'row',
        margin: '9px 10px 0px 10px',
        paddingBottom: '3px',
        paddingTop: '10px',
    },
    title: {
        fontSize: 14,
        fontWeight: 'bold',
        fontFamily: 'Roboto',
    },
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        margin: '8px 10px 0px 10px',
        borderBottomWidth: 1.3,
        borderBottomColor: 'gray',
        borderBottomStyle: 'solid',
        minHeight: 35,
        maxHeight: 100,
    },
    pageNumbers: {
        position: 'absolute',
        flexDirection: 'row',
        flexWrap: 'nowrap',
        bottom: 10,
        left: 0,
        right: 0,
        textAlign: 'center',
        margin: '10px',
        fontSize: 10,
        fontFamily: 'Roboto',
        fontWeight: 'normal',
    },
    listHeaderTitle: { fontSize: '10', fontWeight: 'normal', fontFamily: 'Roboto' },
    listItemFont: { fontSize: '12', fontWeight: 'light', fontFamily: 'Roboto' },
});

Font.register({
    family: 'Roboto',
    fonts: [
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'normal',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'bold',
        },
        {
            src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf',
            fontWeight: 'light',
        },
    ],
});

const dailyScorecardStatus = (item, type) => {
    const checkout = item?.checkout;
    const scorecard = item?.daily_scorecard;

    if (scorecard) {
        const quotas = scorecard.data.quotas ?? [];
        const { status } = scorecard;

        if (!quotas.length) return type === 'status' ? 'No Scorecard' : 'NA';

        if (type === 'status') {
            if (checkout?.status === 1) {
                return 'Completed';
            } else {
                return 'Incomplete';
            }
        } else {
            return status === 2 ? '100%' : `${scorecard?.quota_stats?.percent || 0}%`;
        }
    } else {
        return type === 'status' ? 'No Scorecard' : 'NA';
    }
};

export const EmployeePdf = (data) => {
    const pageTitle = 'Report - Daily Checkout';
    let pageIndex = 1;
    pdf(
        <Document>
            <Page size="letter" style={styles.container} wrap>
                <Header header={pageTitle} style={{ paddingTop: '20px', paddingBottom: '20px' }} fixed />

                {data?.users?.length === 0 ? (
                    <View wrap style={{ display: 'flex', paddingBottom: 20 }}>
                        <View style={styles.listHeader} fixed>
                            <View style={{ flex: 4, textAlign: 'center' }}>
                                <Text style={styles.listHeaderTitle}>No Employee</Text>
                            </View>
                        </View>
                    </View>
                ) : (
                    <View wrap style={{ display: 'flex' }}>
                        <View style={styles.mainHeader} fixed>
                            <View style={{ flex: 4 }}>
                                <Text style={styles.title}>Employees Report</Text>
                            </View>
                        </View>
                        <View style={styles.listHeader} fixed>
                            <View style={{ flex: 3.5 }}>
                                <Text style={styles.listHeaderTitle}>Employees</Text>
                            </View>
                            <View style={{ flex: 1.5 }}>
                                <Text style={styles.listHeaderTitle}>Daily Scorecard</Text>
                            </View>
                            <View style={{ flex: 1.5, textAlign: 'right' }}>
                                <Text style={styles.listHeaderTitle}>Acutals</Text>
                            </View>
                            <View style={{ flex: 1.5, textAlign: 'right' }}>
                                <Text style={styles.listHeaderTitle}>Status</Text>
                            </View>
                            <View style={{ flex: 1.5, textAlign: 'right' }}>
                                <Text style={styles.listHeaderTitle}>Score</Text>
                            </View>
                            <View style={{ flex: 1.5, textAlign: 'right', paddingRight: 5 }}>
                                <Text style={styles.listHeaderTitle}>Date</Text>
                            </View>
                        </View>
                        {data?.users?.map(function (item, index) {
                            const firstName = item?.user?.profile?.first_name || item?.profile?.first_name;
                            const lastName = item?.user?.profile?.last_name || item?.profile?.last_name;
                            const userName = firstName + ' ' + lastName;
                            let scorecardValue;
                            const itemScorecards = item?.daily_scorecard ? [item?.daily_scorecard] : [];
                            if (item.checkout?.status === 2) {
                                const scorecardValues = values(item.checkout?.data?.scorecard);
                                scorecardValue = scorecardValues[0]?.title || 'No Scorecard Assigned';
                            } else if (itemScorecards.length > 0) {
                                const dailyScorecards = itemScorecards.filter((item) => item.type === 0);
                                scorecardValue = dailyScorecards[0]?.title || 'No Scorecard Assigned';
                            } else {
                                scorecardValue = 'No Scorecard Assigned';
                            }

                            let pageBreak = false;
                            if (pageIndex === 13) {
                                pageBreak = true;
                                pageIndex = 1;
                            }
                            pageIndex++;
                            return (
                                <View style={styles.listItem} key={`crd${index}`} wrap break={pageBreak}>
                                    <View style={{ flex: 3.5 }}>
                                        <Text style={styles.listItemFont}>{userName}</Text>
                                    </View>
                                    <View style={{ flex: 1.5 }}>
                                        <Text style={styles.listItemFont}>{scorecardValue}</Text>
                                    </View>
                                    <View style={{ flex: 1.5, textAlign: 'right' }}>
                                        <Text style={styles.listItemFont}>{dailyScorecardStatus(item, 'actuals')}</Text>
                                    </View>
                                    <View style={{ flex: 1.5, textAlign: 'right' }}>
                                        <Text style={styles.listItemFont}>{dailyScorecardStatus(item, 'status')}</Text>
                                    </View>
                                    <View style={{ flex: 1.5, textAlign: 'right' }}>
                                        <Text style={styles.listItemFont}>{item.checkout?.status === 1 ? item.checkout?.data?.score || 0 : 'Incomplete'}</Text>
                                    </View>
                                    <View style={{ flex: 1.5, textAlign: 'right', paddingRight: '5px' }}>
                                        <Text style={styles.listItemFont}>{formatDate(item.checkout?.completed_at)}</Text>
                                    </View>
                                </View>
                            );
                        })}
                    </View>
                )}

                <Text fixed style={styles.pageNumbers} render={({ pageNumber, totalPages }) => `Page ${pageNumber} of ${totalPages}`} />
            </Page>
        </Document>
    )
        .toBlob()
        .then((e) => {
            const url = URL.createObjectURL(e);
            window.open(url, '__blank');
        });
};

const PdfIcon = ({ state, props, name }) => {
    const handlePdf = () => {};
    return <Icon name="fas fa-print" color="#343f4b" size={16} data-cy="hcm-report-trainingSchedulePrintBtn" onClick={handlePdf} />;
};

export default PdfIcon;
